import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from "@material-ui/core";
import { Solvent } from "pages/statuses/Solvent";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        table: {
            minWidth: 250,
        },
        solventsTable: {
            fontSize: `small`,
        },
    })
);

interface Props {
    solvents: Solvent[];
    bookingTypeId: number;
}

/**
 * 溶媒テーブル
 * @param props
 */
export const SolventsTable: React.FC<Props> = (props) => {
    const { solvents, bookingTypeId } = props;
    const classes = useStyles();

    let solventsFiltered: Solvent[] = [];
    switch (bookingTypeId) {
        case 1:
            solventsFiltered = solvents;
            break;
        case 2:
            solventsFiltered = solvents.filter((row) => {
                if (row.pump1Flag) {
                    return row;
                }
            });
            break;
        case 3:
            solventsFiltered = solvents.filter((row) => {
                if (row.pump2Flag) {
                    return row;
                }
            });
            break;
        default:
            break;
    }

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableBody>
                    {solventsFiltered.map((row) => (
                        <TableRow key={row.id} style={{ background: row.colorCode }}>
                            <TableCell className={classes.solventsTable} style={{ minWidth: 180 }}>
                                {row.name}
                            </TableCell>
                            <TableCell className={classes.solventsTable} style={{ minWidth: 80 }}>
                                {row.subName}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
